<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-header bg-white p-3">
        <h5 class="mb-0">Attach to Basecamp Project</h5>
      </div>
      <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
        <div class="d-sm-flex align-items-center">
          <form class="search-box position-relative" @submit.prevent="handleSearch">
            <input type="text" class="form-control shadow-none text-black rounded-0 border-0" placeholder="Search Keywords"
              v-model="searchQuery" />
            <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </form>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  ID
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  NAME
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  ACTIONS
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="basecampProject in filteredBasecampProjects" :key="basecampProject.id">
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ basecampProject.id }}
                </th>
                <th class="shadow-none title lh-1 fw-medium fs-md-15 fs-lg-16 ps-0">
                  {{ basecampProject.name }}
                </th>
                <td class="shadow-none lh-1 fw-medium text-end pe-0">
                    <a class="dropdown-item d-flex align-items-center" href="#" @click="attachBasecampProject(basecampProject.id)">
                    <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                    Attach
                 </a>
                </td>
              </tr>
            </tbody>
          </table>
          <button @click="cleanSetMode()" class="mt-5 default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-info fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          Back To Data Stream
          <i class="flaticon-chevron-1 position-relative ms-5 fs-12"></i>
        </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, inject } from 'vue';
  import { useRouter } from 'vue-router';
  import { SearchProjectByNameOrId, AttachProject } from '@/core/services/entities/task.service'
  import { useToast } from 'vue-toastification'
  import Swal from 'sweetalert2';
  
  
  export default defineComponent({
    name: "BasecampSearchList",
    props: {
      leadID: {
        type: Number,
        required: true
      }
    },
    setup(props) {
      const router = useRouter(); // Initialize the router
      const searchQuery = ref("");
      const filteredBasecampProjects = ref([]);
  
      const fetchBasecampProjects = async (filter = "") => {
        try {
            const response = await SearchProjectByNameOrId(filter);
            filteredBasecampProjects.value = response.basecampProjects;
        } catch (error) {
          console.error('Error fetching Basecamp projects query:', error);
        }
      };

      const attachBasecampProject = async (basecampProjectID) => {
        const toast = useToast();

        // Show confirmation dialog using SweetAlert2
        Swal.fire({
          title: 'Are you sure?',
          text: "Do you want to attach Basecamp Project?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, attach it!'
        }).then(async (result) => {  
          if (result.isConfirmed) {
            try {
              const response = await AttachProject(props.leadID, basecampProjectID);
              toast.success('Attach basecamp project processed successfully!', {
                  timeout: 2000,
                });
            } catch (ex) {
              const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
              toast.error(`Failed to attach basecamp project: ${errorMessage}`, {
                timeout: 2000,
              });
            }
          } else {
            toast.info('Basecamp project attach process canceled.', { timeout: 2000 });
          }
        });

      };
  
      const handleSearch = (event) => {
        event.preventDefault();
        const filter = searchQuery.value.trim();
        fetchBasecampProjects(filter);
      };
  
      const setMode = inject('setMode', (modeSetup) => { console.log('set mode not found')});

        const cleanSetMode = () => {
        if (setMode) {
            setMode('');
        }
        };

      return {
        searchQuery,
        filteredBasecampProjects,
        fetchBasecampProjects,
        handleSearch,
        cleanSetMode,
        attachBasecampProject
      };
    }
  });
  </script>
  
  
  <style scoped>
  .table-responsive {
    min-height: 300px; /* Ensures table has a minimum height */
  }
  
  .table tbody tr.table-row {
    max-height: 50px; /* Ensures each row has a maximum height */
  }
  
  .table tbody tr.placeholder-row {
    height: 50px; /* Placeholder rows to maintain table structure and height */
  }
  
  .table tbody tr.placeholder-row td {
    background: transparent; /* Makes the placeholder rows transparent */
  }
  
  .description-text {
    white-space: wrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  </style>
  